// // import logo from './logo.svg';
// // import './App.css';
// import React, {useState, useRef } from "react";
// import Header from "./components/Header";
// import Hero from "./components/Hero";
// import Services from "./components/Services";
// import About from "./components/About";
// import WhyChooseUs from "./components/WhyChooseUs";
// import ProcessSteps from "./components/ProcessSteps";
// import ContactForm from "./components/ContactForm";
// import Testimonials from "./components/Testimonials";
// import Footer from "./components/Footer";
// import CareerChatbot from "./components/CareerChatBot";
// import Roadmap from "./components/RoadMap";
// import ExtraSections from "./components/ExtraSections";

// function App() {
//   const extraRef = useRef(null);
//   const [quizAnswers, setQuizAnswers] = useState(null);
//   const [chatbotAnswers, setChatbotAnswers] = useState(null);
//   const [isChatOpen, setIsChatOpen] = useState(false);

//   const finalAnswers = quizAnswers || chatbotAnswers;
//   return (
//         <div className="min-h-screen text-brand-700 bg-cream relative">
//       {/* Animated subtle background */}
//       <div className="fixed inset-0 -z-10 bg-animated"></div>
//       <Header className="text-4xl font-bold text-blue-600" onQuizComplete={setQuizAnswers}/>
//       <Hero />
//        {/* Shared Roadmap for both Quiz + Chatbot */}
//       {finalAnswers && <Roadmap answers={finalAnswers} />}

//       {/* Pass setter so chatbot can also fill answers */}
//       <CareerChatbot isOpen={isChatOpen}
//         setIsOpen={setIsChatOpen} onRoadmapClick={setChatbotAnswers} />
//       <Services />
//       <About />
//       <WhyChooseUs />
//       <ProcessSteps />
//       <ExtraSections ref={extraRef}/>
//       <Testimonials />
//       <ContactForm />
//       <Footer onSupportClick={() => setIsChatOpen(true)} onStartRoadmap={() => document.querySelector(".px-5.py-2")?.click()} onQuickLinkClick={(id) => {
//           extraRef.current?.goToSection(id);
//           document.getElementById("extra-sections")?.scrollIntoView({ behavior: "smooth" });
//         }}/>
//     </div>
//   );
// }

// import logo from './logo.svg';
// import './App.css';
import React, {useState, useRef } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import WhyChooseUs from "./components/WhyChooseUs";
import ProcessSteps from "./components/ProcessSteps";
import ContactForm from "./components/ContactForm";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import CareerChatbot from "./components/CareerChatBot";
import Roadmap from "./components/RoadMap";
import ExtraSections from "./components/ExtraSections";
import WhatsAppButton from "./components/WhatsAppButton";
import BlogCareersAfter10th from "./components/blogs/BlogCareersAfter10th";
import BlogEngineeringVsCaVsMedical from "./components/blogs/BlogEngineeringVsCaVsMedical";
import BlogWhenToSwitchJobs from "./components/blogs/BlogWhenToSwitchJobs";
import BlogToast from "./components/BlogToast";

function App() {
  const extraRef = useRef(null);
  const [quizAnswers, setQuizAnswers] = useState(null);
  const [chatbotAnswers, setChatbotAnswers] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [activeBlog, setActiveBlog] = useState(null);

  const finalAnswers = quizAnswers || chatbotAnswers;

  const handleBackToBlog = () => {
    setActiveBlog(null);
    setTimeout(() => {
      extraRef.current?.goToSection("blog");
      document.getElementById("extra-sections")?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const handleConsultationClick = () => {
    setActiveBlog(null);
    setTimeout(() => {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  // If a blog is open, render the full blog page
  if (activeBlog) {
    const blogProps = { onBack: handleBackToBlog, onConsultationClick: handleConsultationClick };
    return (
      <div className="min-h-screen text-brand-700 bg-cream relative">
        <Header className="text-4xl font-bold text-blue-600" onQuizComplete={setQuizAnswers}/>
        {activeBlog === "careers-after-10th" && <BlogCareersAfter10th {...blogProps} />}
        {activeBlog === "engineering-vs-ca-vs-medical" && <BlogEngineeringVsCaVsMedical {...blogProps} />}
        {activeBlog === "when-to-switch-jobs" && <BlogWhenToSwitchJobs {...blogProps} />}
        <ContactForm />
        <Footer onSupportClick={() => setIsChatOpen(true)} onStartRoadmap={() => {
            setActiveBlog(null);
            setTimeout(() => document.querySelector(".px-5.py-2")?.click(), 200);
          }} onQuickLinkClick={(id) => {
            setActiveBlog(null);
            setTimeout(() => {
              extraRef.current?.goToSection(id);
              document.getElementById("extra-sections")?.scrollIntoView({ behavior: "smooth" });
            }, 200);
          }}/>
        <WhatsAppButton />
      </div>
    );
  }

  return (
        <div className="min-h-screen text-brand-700 bg-cream relative">
      {/* Animated subtle background */}
      <div className="fixed inset-0 -z-10 bg-animated"></div>
      <Header className="text-4xl font-bold text-blue-600" onQuizComplete={setQuizAnswers}/>
      <Hero />
       {/* Shared Roadmap for both Quiz + Chatbot */}
      {finalAnswers && <Roadmap answers={finalAnswers} />}

      {/* Pass setter so chatbot can also fill answers */}
      <CareerChatbot isOpen={isChatOpen}
        setIsOpen={setIsChatOpen} onRoadmapClick={setChatbotAnswers} />
      <Services />
      <About />
      <WhyChooseUs />
      <ProcessSteps />
      <ExtraSections ref={extraRef} onBlogOpen={setActiveBlog}/>
      <Testimonials />
      <ContactForm />
      <Footer onSupportClick={() => setIsChatOpen(true)} onStartRoadmap={() => document.querySelector(".px-5.py-2")?.click()} onQuickLinkClick={(id) => {
          extraRef.current?.goToSection(id);
          document.getElementById("extra-sections")?.scrollIntoView({ behavior: "smooth" });
        }}/>
      {/* <WhatsAppButton /> */}
      <BlogToast onBlogOpen={setActiveBlog} />
    </div>
  );
}

export default App;
